import React from "react";

export default function PropertyTableInventorySkeleton() {
  return (
    <div className="mt-3 flex flex-col">
      <div className="inline-block min-w-full align-middle">
        <div className=" shadow-sm ring-1 ring-black ring-opacity-5 rounded-lg overflow-x-auto">
          <table className="min-w-full sm:divide-y sm:divide-gray-300">
            <thead className="hidden bg-gray-50 sm:table-header-group">
              <tr>
                <th className="px-12 py-3 text-xs font-medium tracking-wide text-left text-gray-900 sm:pl-6"></th>
                <th
                  scope="col"
                  className=" py-3.5 px-2 text-left text-sm font-semibold text-gray-900"
                >
                  Tipo de propiedad
                </th>
                <th
                  scope="col"
                  className=" py-3.5 px-2 text-left text-sm font-semibold text-gray-900"
                >
                  Inmobiliaria
                </th>
                <th
                  scope="col"
                  className=" py-3.5 px-2 text-left text-sm font-semibold text-gray-900"
                >
                  Teléfono
                </th>
                <th
                  scope="col"
                  className=" py-3.5 px-2 text-left text-sm font-semibold text-gray-900"
                >
                  Ubicación
                </th>
                <th
                  scope="col"
                  className=" py-3.5 px-2 text-left text-sm font-semibold text-gray-900"
                >
                  Promotor
                </th>
                <th
                  scope="col"
                  className=" py-3.5 px-2 text-left text-sm font-semibold text-gray-900"
                >
                  Comisión compartida
                </th>
                <th
                  scope="col"
                  className="py-3.5 px-2 text-left text-sm font-semibold text-gray-900"
                >
                  Precio
                </th>
                <th
                  scope="col"
                  className="py-3.5 px-2 text-left text-sm font-semibold text-gray-900"
                >
                  Descargar PDF
                </th>
              </tr>
            </thead>
            <tbody className="bg-white animate-pulse">
              {[...Array(5)].map((_, i) => (
                <tr key={i} className={i % 2 === 0 ? undefined : "bg-gray-50"}>
                  <td className="flex items-center gap-3 py-2 align-middle sm:px-2">
                    <div className="h-[100px] w-[100px] md:h-[120px] md:w-[120px] rounded-lg bg-gray-300" />
                  </td>
                  <td className="px-1 py-4 sm:px-3">
                    <div className="flex gap-1">
                      <div className="flex flex-col space-y-2">
                        <div className="h-4 w-16 bg-gray-300 rounded" />
                        <div className="h-4 w-24 bg-gray-300 rounded" />
                      </div>
                    </div>
                  </td>
                  <td className="px-3 py-4">
                    <div className="h-5 w-20 bg-gray-300 rounded-md sm:ml-3" />
                  </td>
                  <td className="px-3 py-4">
                    <div className="h-4 w-24 bg-gray-300 rounded sm:ml-3" />
                  </td>
                  <td className="relative py-3 pl-3 pr-4 sm:pr-6">
                    <div className="h-5 w-48 bg-gray-300 rounded" />
                  </td>
                  <td className="relative py-3 pl-3 pr-4 sm:pr-6">
                    <div className="h-5 w-32 bg-gray-300 rounded" />
                  </td>
                  <td className="relative py-3 pl-3 pr-4 sm:pr-6">
                    <div className="h-5 w-32 bg-gray-300 rounded" />
                  </td>
                  <td className="hidden sm:table-cell px-3 py-4">
                    <div className="flex flex-col space-y-2">
                      <div className="h-4 w-24 bg-gray-300 rounded" />
                      <div className="h-4 w-24 bg-gray-300 rounded" />
                      <div className="h-4 w-24 bg-gray-300 rounded" />
                    </div>
                  </td>
                  <td className="relative py-3 pl-3 pr-4 sm:pr-6">
                    <div className="flex items-center justify-center">
                      <div className="h-5 w-5 bg-gray-300 rounded" />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
